<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="mb-3">
      <v-toolbar-title>
        <v-btn icon round :to="spaces"><v-icon>arrow_back</v-icon></v-btn>
        {{ space.name}}
        <v-btn v-if="canEdit(space)" icon small color="success" :to="'/spaces/' + space.id + '/edit'"><v-icon size="18">edit</v-icon></v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="canEdit(space)"
        color="primary"
        @click="openUsersModal"
      >
        Add users
      </v-btn>
    </v-toolbar>

    <add-users-dialog
      v-if="showDialog"
      ref="addUsers"
      :articles="transformArticles(articles)"
      :users="space.instance_users"
      :space="space"
      @onClose="refreshDialog"
    />

    <v-layout wrap>
      <v-flex xs12 sm3 pt-2 pr-2>
        <v-card class="elevation-5">
          <v-text-field
            prepend-inner-icon="search"
            label="Search Articles"
            clearable
            class="px-3 pt-3"
            v-model="search"
          ></v-text-field>
          <v-card-text class="pt-1">
            <tree-view :space_id="$route.params.space_id" :items="articles"></tree-view>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm9 pt-2 pl-2>
        <v-card class="elevation-5">
          <v-card-text>
            <div v-if="article.id && !article.deleted">
              <div class="articles_head">
                <h1>{{ article.name }}</h1>
                <div>
                  <v-btn v-if="canEdit(article)" icon small color="success"
                         :to="'/spaces/' + space.id + '/articles/' + article.id + '/edit'">
                    <v-icon size="18">edit</v-icon>
                  </v-btn>
                  <remove-dialog v-if="canDelete(article)" :yes="() => removeArticle(article)">
                    <v-btn icon small color="error" :ripple="false">
                      <v-icon size="18">close</v-icon>
                    </v-btn>
                  </remove-dialog>
                </div>
              </div>
              <div v-if="article.children">
                <ul v-if="article.children.length">
                  <li v-for="article in article.children">
                    <router-link :to="'/spaces/' + article.space_id + '/articles/' + article.id">{{ article.name }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="mark_down__wrapper" style="border-top: 2px solid #ccc; margin-top: 15px; padding-top: 10px">
                <vue-markdown :source="article.text"></vue-markdown>
              </div>
            </div>
            <div v-else>
              Current article not exits, or was removed.
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as mixins from '@/mixins/'
import tree from '@/components/spaces/tree'
import VueMarkdown from 'vue-markdown'
import { mapGetters } from 'vuex'
import SlExtendedSelect from '@/components/sl-extended-select.vue'
import AddUsersDialog from '@/components/spaces/add-users-dialog.vue'

export default {
    name: 'ArticleView',
    mixins: [mixins.removable, mixins.preloader, mixins.history, mixins.user],
    data() {
      return {
        api: this.$api.articles,
        articles: [],
        search: '',
        article: {
          deleted: false,
          children: [],
          users: [],
          user: {}
        },
        space: {
          name: '',
          id: this.$route.params.id,
          user: {},
          users: [],
          instance_users: [],
        },
        showDialog: true,
      }
    },
    computed: {
      ...mapGetters(["spaces"]),
    },
    methods: {
      refresh() {
        this.queue(this.loadTree())
        this.getArticle()

        this.background(this.getSpace())
      },
      getArticle() {
        if (this.$route.params.article_id) {
          return this.$api.articles.get(this.$route.params.article_id).then(({success, data}) => {
            this.article = data
            this.updateTitle("[SL] " + this.article.name)
          }, (data) => {
            this.article = {...this.article, deleted: true}
          })
        }
      },
      getSpace() {
        return this.$api.spaces.get(this.$route.params.space_id).then(response => {
          this.space = response.data
        })
      },
     transformArticles(arr) {
      return arr.map(({ id, name , tree }) => {
        const transformedItem = { id, name };

        if (tree && tree.length) {
          transformedItem.children = this.transformArticles(tree);
        }

        return transformedItem;
      });
    },
      loadTree() {
        let params = {
          space_id: this.$route.params.space_id,
          search: this.search,
          tree: 1,
        }
        return this.api.list(params).then((response) => {
          this.articles = response.data.data ? response.data.data : response.data
          if (this.articles.length) {
            this.$router.push({
              name: 'articles-tree',
              params: {space_id: this.$route.params.space_id, article_id: this.$route.params.article_id ? this.$route.params.article_id : this.articles[0].id}
            })
          }
        })
      },
      removeArticle(article) {
        this.remove(article, () => {
          this.queue(this.loadTree())
          this.getArticle()
        })
      },
      openUsersModal() {
        this.$refs.addUsers.open()
      },
      refreshDialog() {
        this.showDialog = false
        this.getSpace()
        this.$nextTick(() => {
          this.showDialog = true
        })
      },
    },
    watch: {
      '$route.params.article_id': {
        handler: function () {
          this.getArticle()
        },
        deep: true
      },
      'search'() {
        clearTimeout(this.timer)
        this.timer = setTimeout(()=> {
          this.articles = []
          this.refresh()
        }, 500)
      }
    },
    components: {
      AddUsersDialog,
      SlExtendedSelect,
      'tree-view': tree,
      VueMarkdown
    },
    mounted() {
      this.search = ''
      this.refresh()
    }
  }
</script>
